// Hook: loads standard costs from Supabase portal_config table.
// Phase 4: Added in-memory cache to avoid re-fetching on every mount.
// TypeScript source — useStandardCosts.js is a thin re-export stub.

import React from "react";
import { getConfigValue } from "../data/portalConfig";
import { DEFAULT_STANDARD_COSTS } from "../utils/formConstants";

type StandardCostsShape = typeof DEFAULT_STANDARD_COSTS;

// In-memory cache — shared across all components using this hook
var _cachedCosts: StandardCostsShape | null = null;
var _cacheTime = 0;
var CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function useStandardCosts() {
  var state = React.useState<StandardCostsShape>(_cachedCosts || DEFAULT_STANDARD_COSTS);
  var costs = state[0];
  var setCosts = state[1];
  var loaded = React.useState(!!_cachedCosts);
  var isLoaded = loaded[0];
  var setLoaded = loaded[1];

  React.useEffect(function () {
    // Use cache if fresh
    if (_cachedCosts && Date.now() - _cacheTime < CACHE_TTL) {
      setCosts(_cachedCosts);
      setLoaded(true);
      return;
    }
    getConfigValue("standard_costs").then(function (value) {
      var merged: StandardCostsShape = DEFAULT_STANDARD_COSTS;
      if (value) {
        merged = Object.assign({}, DEFAULT_STANDARD_COSTS, value);
      }
      _cachedCosts = merged;
      _cacheTime = Date.now();
      setCosts(merged);
      setLoaded(true);
    });
  }, []);

  return { costs: costs, isLoaded: isLoaded };
}

// Call this after saving new costs in admin to bust the cache
export function invalidateStandardCostsCache() {
  _cachedCosts = null;
  _cacheTime = 0;
}
